module.exports = __webpack_public_path__ + "img/likebg.c7eab42b.png";